<template>
  <div>
    <page-embedded-player/>
  </div>
</template>

<script>
import PageEmbeddedPlayer from '../pages/page-embedded-player';

export default {
  name: 'app-embedded',
  components: { PageEmbeddedPlayer }
};
</script>

<style lang="scss">

  @import "../style/color_";
  @import "../style/base_";
  @import "../style/typography_";
  @import "../style/table_";
  @import "../style/form_";
  @import "../style/button_";
  @import "../style/layout_";
  @import "../style/config_";
  @import "../style/docs_";

  $size-container-width: 1024px;

  html, body, .viewport {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    min-width: 320px;
  }

  body {
    font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
    font-size: 14px;
    color: $color-dark-gray;
    background-color: $color-background-page;
  }

  ul, li {
    padding: 0;
    margin: 0;
  }

  .pp-app-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;

    max-width: $size-container-width;
    margin: auto;
    background-color: $color-background-content;
  }

  .clearfix {
    overflow: auto;
  }

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: $color-background-content;
  }

  ::-webkit-scrollbar-thumb {
    background-color: $color-quaternary;
  }

  header {
    background-color: $color-cl-red;
    background-image: url("../assets/logo-white.png");
    background-repeat: no-repeat;
    background-position: 8px 16px;
    background-size: auto 35px;

    position: relative;

    .title {
      color: white;
      font-size: 20px;

      text-align: center;
      margin-top: 68px;
    }

    button {
      border: 1px solid white;
      background-color: transparent;
      color: white;
      font-size: 14px;
      border-radius: 5px;
      /*padding: 8px;*/
      text-transform: none;
      cursor: pointer;

      position: absolute;
      top: 0;
      right: 0;
      margin: 16px;
    }
  }

  footer {
    padding: 8px;
    ul {
      width: 100%;
      color: $color-light-gray;
      font-size: 12px;
      text-align : center;
      li {
        display: inline;
        margin-left: 4px;
      }
      li:after {
        content: " \2022 ";
      }
      li:last-child:after {
        content: "";
      }
    }
  }

  .pp-toolbar {
    overflow: auto;
    white-space: nowrap;
    width: 100%;
    display: flex;
    flex-direction: row;

    ul {
      overflow: auto;
      flex: 1 1 auto;

      color: $color-light-gray;
      background-color: $color-toolbar-bg;
      font-size: 12px;

      li {
        cursor: pointer;
        display: inline-block;
        text-align : center;
        font-size: 16px; // TODO: make bigger on ms 18
        margin: 0 12px; // 16
        padding: 12px 8px; // 16
      }

      li.router-link-exact-active {
        color: $color-cl-red;
        border-bottom: 2px solid$color-cl-red;
      }
    }
  }
  .pp-toolbar-transparent {
    ul {
      background-color: transparent;
      flex-grow: 0;
    }
  }

  .primary-links {
    .router-link-active {
      color: $color-cl-red;
      border-bottom: 2px solid$color-cl-red;
    }
  }

  .pp-content {
    flex: 1 0;
    /*padding: 8px;*/
  }

  @media (min-width: 600px){
    header {
      height: 68px;

      .title {
        margin: auto auto auto 200px;
        padding-top: 18px;
        text-align: left;
        font-size: 20px;
        height: 100%;
      }
    }
    footer {
      padding-top: 16px;
      padding-bottom: 16px;
    }

    .pp-toolbar {
      ul {
        li {
          font-size: 18px;
          margin: 0 16px;
          padding: 16px;
        }
      }
    }
  }

  .scroll-on-focus {
    overflow: hidden;
  }
</style>
